export default [
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('@/views/sistema/usuarios/list/Index.vue'),
    meta: {
      pageTitle: 'Usuários',
      action: 'read',
      resource: 'Usuarios',
    },
  },
];
